import { Card } from 'antd';
import { CardProps } from 'antd/es';
import { ReactElement } from 'react';

interface ChartWrapperProps extends CardProps {
  title?: string | ReactElement;
}

const ChartWrapper = ({ children, title, style, ...rest }: ChartWrapperProps) => {
  return <Card {...{ ...rest, title, style: { overflow: 'hidden', ...style } }}>{children}</Card>;
};

export default ChartWrapper;
